module.exports = __webpack_public_path__ + "static/media/29ADMSPC8.df998499.jpg";